import React from 'react'
import Modal from 'components/_UI/Modal'
import Text from 'components/_UI/Text'
import Button from 'components/_UI/Button'
import buttonText from 'texts/buttons/buttonText'
import styled from 'styled-components'

export default function ConfirmDeleteModal({
    isOpen,
    title = 'Confirmar exclusão',
    message = 'Tem certeza que deseja excluir? Esta ação não pode ser desfeita.',
    onConfirm = () => {},
    onCancel = () => {}
}) {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onCancel}
            closeButton
            size='default'
        >
            <Text name='highlight' marginBottom='8px'>
                {title}
            </Text>
            <Text name='default' marginBottom='20px'>
                {message}
            </Text>
            <ButtonRow>
                <Button variant='secondary' onClick={onCancel}>
                    {buttonText.cancel}
                </Button>
                <Button variant='danger' onClick={onConfirm}>
                    {buttonText.delete}
                </Button>
            </ButtonRow>
        </Modal>
    )
}

const ButtonRow = styled.div`
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 8px;
`
